"use client";

import { Search, X } from "lucide-react";
import { cn } from "@/lib/utils";

export const PROFILE_SEARCH_ROW_HEIGHT = 48;

type ProfileSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel?: string;
  variant?: "expanded" | "compact";
  className?: string;
  clearLabel?: string;
};

export function ProfileSearchField({
  value,
  onChange,
  placeholder,
  ariaLabel,
  variant = "expanded",
  className,
  clearLabel = "Clear search",
}: ProfileSearchFieldProps) {
  const compact = variant === "compact";

  return (
    <div
      className={cn(
        "flex w-full min-w-0 items-center gap-2 rounded-full border border-border bg-muted/50",
        compact ? "min-h-10 px-3 py-2" : "h-12 px-3.5",
        className,
      )}
    >
      <Search className={cn("shrink-0 text-muted-foreground", compact ? "h-3.5 w-3.5" : "h-4 w-4")} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn(
          "min-h-0 min-w-0 flex-1 bg-transparent py-0 text-[16px] leading-normal text-foreground placeholder:text-muted-foreground outline-none [appearance:textfield]",
        )}
        autoCorrect="off"
        autoCapitalize="none"
        enterKeyHint="search"
        aria-label={ariaLabel ?? placeholder}
      />
      {value.length > 0 ? (
        <button
          type="button"
          onClick={() => onChange("")}
          className="shrink-0 rounded-full p-0.5 text-muted-foreground hover:text-foreground"
          aria-label={clearLabel}
        >
          <X className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
        </button>
      ) : null}
    </div>
  );
}
